import { HawkersReportTranslations } from "./hawkers-report-pt-br";

export const HAWKERS_REPORT_FR_FR: HawkersReportTranslations = {
	title: "Panneau ambulant",
	description: "Voir les performances générales des vendeurs ambulants sur place",
	general: {
		title: "Panneau Général",
		hawkerSelect: "Sélectionnez un ambulant",
		totalizers: {
			launchedProductsTotal: "Total des produits lancés",
			returnedProductsTotal: "Total des produits retournés",
			commissionTotal: "Total des commissions",
			salesTotal: "Ventes totales",
		},
		table: {
			sales: "Ventes",
			devolutions: "Retours",
			paymentMethod: "Modes de paiement",
			productsRelease: "Version du produit",
			productsCancellation: "Annulation du produit",
			noReturnNoSalesProducts: "Produits sans retour et sans vente",
			columns: {
				product: "Produit",
				quantity: "Quantité",
				unitValue: "Valeur unitaire",
				total: "Total",
				commission: "Commission",
				paymentMethod: "Mode de paiement",
				value: "Valeur",
			},
		},
	},
	summary: {
		title: "Résumé par session et cycle",
		summary: "Résumé",
		filterBreak: "Afficher uniquement les sessions avec pauses",
		filterClosure: "Afficher uniquement les sessions en attente de fermeture",
		filterDifferentCashiers: "Afficher uniquement les sessions avec caisses différentes",
		columns: {
			session: "Séance",
			hawkerName: "Ambulant",
			hawkerDocument: "Document",
			cycleCount: "Cycles",
			change: "Changer",
			receivedValue: "Valeur reçue",
			break: "Pause de boîte",
			openedAt: "Ouverture",
			closedAt: "Fermeture",
			openClosure: "Ouvrir la fermeture",
			cycle: "Cycle",
			previousBalance: "Solde précédent",
			closingValue: "Valeur de clôture",
			balance: "Solde final",
			cashierNameOpener: "Ouverture de la caisse",
			cashierNameCloser: "Fermeture de la caisse",
			pub: {
				initial: "Bar de ouverture",
				final: "Bar de fermeture",
			},
		},
	},
	ranking: {
		title: "Classement",
		filename: "classement",
		columns: {
			name: "Nom",
			document: "Document",
			commission: "Commission",
			total: "Total vendu",
		},
	},
	releases: {
		title: "Lancements par des vendeurs ambulants",
		quantityProducts: "Quantité de produits",
		totalValueReleases: "Valeur totale",
		filename: "record-de-ambulant-{{hawker}}",
		hawkerRecord: "Record de ambulants",
		name: "Nom du ambulant",
		columns: {
			hawkerName: "Nom",
			hawkerDocument: "Document",
			total: "Total",
			productName: "Produit",
			quantity: "Quantité",
			value: "Valeur unitaire",
			cycle: "Cycle",
			date: "Date/Heure",
		},
	},
	cashierClosing: {
		title: "Fermeture de la ambulant box",
		name: "Nom",
		document: "Document",
		begin: "Ouverture",
		end: "Fermeture",
		closingValue: "Valeur de clôture",
		financialResume: "Résumé financier",
		resume: "Résumé",
		value: "Valeur",
		products: "Produits",
		product: "Produit",
		quantity: "Quantité",
		unitValue: "Valeur unitaire",
		total: "Total",
		paymentMethods: "Modes de paiement",
		paymentMethod: "Mode de paiement",
		date: "Date et heure",
		changeEntries: "Sorties de monnaie",
		bleedings: "Saignements",
		cycleClosings: "Fermetures de cycles",
		sessionClosings: "Fermetures de session",
		financialSummaryTitles: {
			changeFundsValue: "Changement total",
			bleedingsValue: "Saignement total",
			cyclesReceivedValue: "Totalisateur de cycles",
			sessionsReceivedValue: "Totalisateur de session",
			cashValue: "Valeur de rachat",
			valueWithCashier: "Montant détenu par le caissier",
			cashierDiffValue: "Caissier fermé avec casse/excédent",
			commissionsValue: "Commission",
		},
		diffValue: "Pénurie/excédent de liquidités",
	},
	filter: {
		filter: "Filtre",
		clickToFilter: "Cliquez pour filtrer",
		employee: {
			label: "Employé",
			description: "Entrez le nom de l'employé",
			title: "Filtrer par salarié",
		},
		hawkerName: {
			label: "Nom du vendeur ambulant",
			description: "Entrez le nom du vendeur ambulant",
			title: "Filtrer par nom de vendeur ambulant",
		},
		hawkerDocument: {
			label: "Document du vendeur ambulant",
			description: "Saisir le document du vendeur ambulant",
			title: "Filtrer par document de vendeur ambulant",
		},
		cashierName: {
			label: "Nom du caissier",
			description: "Entrez le nom du caissier",
			title: "Filtrer par nom de caissier",
		},
		cashierDocument: {
			label: "Document de caisse",
			description: "Saisir le document de caisse",
			title: "Filtrer par pièce de caisse",
		},
		eventTypes: {
			label: "Type de mouvement",
			description: "Sélectionnez un type de mouvement",
			title: "Filtrer par type de mouvement",
		},
		productName: {
			label: "Nom du produit",
			description: "Saisir le nom du produit",
			title: "Filtrer par nom de produit",
		},
		barName: {
			label: "Nom du bar",
			description: "Saisir le nom du bar",
			title: "Filtrer par nom de bar",
		},
		cycleId: {
			label: "Cycle",
			description: "Saisir l'ID du cycle",
			title: "Filtrer par cycle",
			error: "Veuillez entrer un ID valide",
		},
		sessionId: {
			label: "Session",
			description: "Saisir l'ID de la session",
			title: "Filtrer par session",
			error: "Veuillez entrer un ID valide",
		},
		employeeLogin: {
			label: "Login de l'employé",
			description: "Saisir le login de l'employé",
			title: "Filtrer par login de l'employé",
		},
	},
	transactions: {
		title: "Transactions de Vendeur Ambulant",
		description: "Liste des transactions du vendeur ambulant dans le contexte du lieu",
		columns: {
			id: "ID du mouvement",
			hawkerName: "Nom du Vendeur Ambulant",
			hawkerDocument: "Document du Vendeur Ambulant",
			productId: "ID du Produit",
			productName: "Produit",
			productCategory: "Catégorie du produit",
			barId: "ID du bar",
			barName: "Nom du bar",
			cashierId: "ID du caissier",
			cashierName: "Nom du Caissier",
			cycleId: "Cycle",
			openedAt: "Date et heure d'ouverture",
			closedAt: "Date et heure de fermeture",
			eventType: "Type de mouvement",
			createdAt: "Date/heure de mouvement",
			eventId: "Event ID",
			eventName: "Nom de l'Événement",
			quantity: "Quantité",
			amount: "Valeur",
			cashierDocument: "Document du Caissier",
			employeeName: "Nom de l'employé",
			paymentMethod: "Méthode de paiement",
			paymentValue: "Valeur payée",
			unitValue: "Valeur unitaire",
			totalValue: "Valeur totale",
			sessionId: "Session",
			discount: "Remise",
			commission: "Commission",
			balance: "Solde du cycle/session de clôture",
			employeeLogin: "Login de l'employé",
			serial: "Série du terminal",
			deviceId: "ID du dispositif",
			productTotal: "Total du produit",
			hawkerEmployee: "Login de l'employé du vendeur ambulant",
			cashierEmployee: "Login de l'employé du caissier",
		},
		filter: {
			actionsType: "Sélectionnez un type de mouvement",
			employee: "Nom de l'employé",
			hawker: "Nom ou document du vendeur ambulant",
			cashier: "Nom ou document de caisse",
		},
		sessionOpening: "Ouverture de session",
		sessionClosure: "Fermeture de session",
		cycleOpening: "Ouverture de cycle",
		cycleClosure: "Fermeture de cycle",
		productRelease: "Sortie de vendeur ambulant",
		sale: "Ventes de vendeur ambulant",
		bleeding: "Saignement",
		changeFund: "Changement de fonds",
		devolution: "Retours de produits de vendeur ambulant",
		cashierOpening: "Ouverture de caisse",
		cashierClosure: "Fermeture de caisse",
		cancellation: "Annulation",
		maxSearchPeriod: "La période de recherche maximale est de 31 jours",
	},
};
